import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core';
import {
  InputComponent,
  SelectComponent,
  TextareaComponent,
} from '@ansys-internal/awc-angular/forms';
import { CommonModule } from '@angular/common';
import {
  ButtonComponent,
  ButtonSize,
  ButtonType,
} from '@ansys-internal/awc-angular/buttons';
import {
  IconComponent,
  Icons,
  IconType,
} from '@ansys-internal/awc-angular/icons';
import {
  AWFNotificationProvider,
  DIALOG_DATA,
  DIALOG_REF,
  NOTIFICATION_PROVIDER,
  ProductContextService,
  SnackBarService,
} from '@ansys-internal/awf-angular/shared';
import {
  INSTANCE_ICON,
  INSTANCE_TITLE,
} from '@ansys-internal/awf-angular/dashboard';
import { ComponentWidth } from '@ansys-internal/awc-angular/core';
import { ConceptService } from '../../../shared/services/concept.service';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
    selector: 'app-create-concept-from-file-dialog',
    imports: [
        CommonModule,
        InputComponent,
        ButtonComponent,
        TextareaComponent,
        IconComponent,
    ],
    templateUrl: './create-concept-from-file-dialog.component.html',
    styleUrl: './create-concept-from-file-dialog.component.scss'
})
export class CreateConceptFromFileDialogComponent {
  @ViewChild('fileUpload') upload!: ElementRef;
  public title: string = '';
  public description: string = '';
  protected file?: File;
  protected loading: boolean = false;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected readonly ButtonSize = ButtonSize;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected readonly ButtonType = ButtonType;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected readonly ComponentWidth = ComponentWidth;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected readonly Icons = Icons;

  constructor(
    @Inject(DIALOG_DATA)
    protected data: {
      projectId: string;
    },
    @Inject(DIALOG_REF) private dialogRef: DialogRef,
    @Inject(INSTANCE_TITLE) protected instanceTitle: string,
    @Inject(NOTIFICATION_PROVIDER)
    private notifications: AWFNotificationProvider,
    @Inject(INSTANCE_ICON) protected prefixIcon: IconType, // TODO: This can be used in the project column contributed item
    private conceptService: ConceptService,
    private snackbar: SnackBarService,
    protected cdr: ChangeDetectorRef,
    private productContextService: ProductContextService
  ) {}

  protected onUploadClicked(): void {
    this.upload.nativeElement.click();
  }

  protected onFileSelected(event: Event): void {
    const target = event.target as HTMLInputElement;

    const file = target.files?.[0];
    if (file) {
      this.file = file;
    }
  }

  protected async onCreateDesign(): Promise<void> {
    if (!this.file || !this.title) {
      return;
    }
    this.loading = true;

    const file: File = this.file;

    await this.conceptService
      .createConceptFromFile(
        file,
        this.data.projectId,
        this.title ?? 'Branch 1',
        this.description
      )
      .catch((e) => {
        this.loading = false;
        this.cdr.detectChanges();
        throw new Error(e);
      });

    this.snackbar.success(`${this.instanceTitle} Created`);
    this.notifications.addNotification({
      text: `Project ${this.instanceTitle} Created`,
      subText: `${this.instanceTitle} created`,
      prefixIcon: this.prefixIcon,
    });

    this.dialogRef.close();

    this.loading = false;
  }
}
